function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.5303 6.46967C11.8232 6.76256 11.8232 7.23744 11.5303 7.53033L7.06066 12L11.5303 16.4697C11.8232 16.7626 11.8232 17.2374 11.5303 17.5303C11.2374 17.8232 10.7626 17.8232 10.4697 17.5303L5.46967 12.5303C5.17678 12.2374 5.17678 11.7626 5.46967 11.4697L10.4697 6.46967C10.7626 6.17678 11.2374 6.17678 11.5303 6.46967Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.5303 6.46967C18.8232 6.76256 18.8232 7.23744 18.5303 7.53033L14.0607 12L18.5303 16.4697C18.8232 16.7626 18.8232 17.2374 18.5303 17.5303C18.2374 17.8232 17.7626 17.8232 17.4697 17.5303L12.4697 12.5303C12.1768 12.2374 12.1768 11.7626 12.4697 11.4697L17.4697 6.46967C17.7626 6.17678 18.2374 6.17678 18.5303 6.46967Z",
  fill: "currentColor"
});

function SvgChevronsLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronsLeft);
export default __webpack_public_path__ + "static/media/chevrons-left.66befdf1.svg";
export { ForwardRef as ReactComponent };